// extracted by mini-css-extract-plugin
export var text = "_e-0";